import { Navigate, Route, Routes } from 'react-router-dom';
import { PoolDocumentTitle } from '@synergy/components-next';

import { PaloConfigurationShell } from '../../palo/palo-configuration-shell';
import { SearchConsoleTab } from '../models/search-console-tab';
import { SearchCurationView } from './search-curation-view';
import { SearchDictionaryView } from './search-dictionary-view';
import { SearchExplainView } from './search-explain-view';
import { SearchJudgementView } from './search-judgement-view';
import { SearchPreviewView } from './search-preview-view';
import { SearchSituationView } from './search-situation-view';
import { SearchWorklistView } from './search-worklist-view';

/**
 * How far back the console looks. The concept fixes the situation view on the last
 * 30 days; a shorter window would let a quiet weekend look like a regression.
 */
export const SEARCH_CONSOLE_DAYS = 30;

/**
 * Konfiguration › Suche: what the search did, where it is weak, and why a result
 * looks the way it does (#2173). Every number comes from the search-quality
 * endpoints — the console renders, it never computes.
 */
export const PaloSearchConsole = () => {
    return (
        <>
            <PoolDocumentTitle titleTranslationId="app.configuration.title.search" />
            <PaloConfigurationShell
                title="app.configuration.title.search"
                tabs={[
                    { value: SearchConsoleTab.Situation, label: 'app.searchConsole.tab.situation' },
                    { value: SearchConsoleTab.Worklist, label: 'app.searchConsole.tab.worklist' },
                    { value: SearchConsoleTab.Explain, label: 'app.searchConsole.tab.explain' },
                    { value: SearchConsoleTab.Preview, label: 'app.searchConsole.tab.preview' },
                    { value: SearchConsoleTab.Judgement, label: 'app.searchConsole.tab.judgement' },
                    { value: SearchConsoleTab.Dictionary, label: 'app.searchConsole.tab.dictionary' },
                    { value: SearchConsoleTab.Curation, label: 'app.searchConsole.tab.curation' },
                ]}
            >
                <Routes>
                    <Route index={true} element={<Navigate to={SearchConsoleTab.Situation} replace={true} />} />
                    <Route path={SearchConsoleTab.Situation} element={<SearchSituationView />} />
                    <Route path={SearchConsoleTab.Worklist} element={<SearchWorklistView />} />
                    <Route path={SearchConsoleTab.Explain} element={<SearchExplainView />} />
                    <Route path={SearchConsoleTab.Preview} element={<SearchPreviewView />} />
                    <Route path={SearchConsoleTab.Judgement} element={<SearchJudgementView />} />
                    <Route path={SearchConsoleTab.Dictionary} element={<SearchDictionaryView />} />
                    <Route path={SearchConsoleTab.Curation} element={<SearchCurationView />} />
                </Routes>
            </PaloConfigurationShell>
        </>
    );
};
